import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsAccountsButtonControl } from "../ags-accounts-button-control";

export class AgsAccountsButtonControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("ags_accounts") != null;
    }

    public build(layer: Layers): AgsAccountsButtonControl[] {
        return [new AgsAccountsButtonControl(layer.getFlexiButton("ags_accounts"))];
    }
}
